import type { TickerActivityRecord } from '@/modules/ticker/types';

/** Cookie name used to persist the user's last-selected ticker item. */
export const SELECTED_TICKER_COOKIE = 'selected-ticker';

/**
 * Stable identifier for a ticker record — survives reordering across requests.
 * - team_leagues use their UUID (always present for our MLP entries)
 * - tournaments use partnersFlag (e.g. 'PPA', 'PPA Australia', 'PPA Asia')
 *
 * Prefix disambiguates the namespaces so a future tournament partnersFlag
 * can never collide with a team league UUID.
 */
export function getTickerKey(
  record: Pick<TickerActivityRecord, 'type' | 'partnersFlag' | 'teamLeagueUuid'>
): string {
  if (record.type === 'team_league' && record.teamLeagueUuid) {
    return `tl:${record.teamLeagueUuid}`;
  }
  return `t:${record.partnersFlag}`;
}

/** Format check — used by both writer (action) and reader (server component). */
export function isValidTickerKey(key: unknown): key is string {
  return typeof key === 'string' && key.length > 0 && key.length <= 100 && /^(tl|t):/.test(key);
}
